import React from "react";
import { Link } from "react-router-dom";
import { Lock, Crown, ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useFeatureAccess } from "@/hooks/useFeatureAccess";

/**
 * Wraps a route/component and blocks access when the current user's plan
 * does not include this feature. Sysadmin/Admin bypass automatically.
 */
export default function FeatureGate({ featureId, label, children }) {
  const { ready, canAccess, planLabel } = useFeatureAccess();
  if (!ready) return <div className="p-8 text-center text-sm text-muted-foreground" data-testid="feature-gate-loading">Memuat…</div>;
  if (canAccess(featureId)) return children;
  return (
    <div className="mx-auto max-w-xl py-16 text-center" data-testid={`feature-locked-${featureId}`}>
      <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-primary/10">
        <Lock className="h-7 w-7 text-primary" />
      </div>
      <h2 className="mt-6 font-heading text-3xl font-semibold">Fitur terkunci</h2>
      <p className="mt-3 text-sm text-muted-foreground">
        Fitur <b>{label || featureId}</b> tidak tersedia di <b>{planLabel}</b> Anda.
        Upgrade paket untuk membuka akses.
      </p>
      <div className="mt-6 flex items-center justify-center gap-2">
        <Link to="/paket">
          <Button data-testid={`upgrade-btn-${featureId}`} className="gap-2">
            <Crown className="h-4 w-4" /> Upgrade Paket <ArrowRight className="h-4 w-4" />
          </Button>
        </Link>
      </div>
    </div>
  );
}
